import { ComponentRendering } from '@sitecore-jss/sitecore-jss-react';
import {
  TCHSeriesDetailDownloadBrochuresDataAssets,
  TCHSeriesDetailDownloadBrochuresInnerComponent,
  TCHSeriesDetailDownloadBrochuresParams,
  TCHSeriesDetailDownloadBrochuresProps,
} from '../types/productSeriesDetailDownloadBrochures.types';
import { StringField } from '../../../types/types';
import { BACKGROUND_COLOR_MAP } from '../../../constants/background-color.constants';
import { appendRootToRichTextInternalLinks } from '../../../utils/appendRootToRichTextInternalLinks.utils';

export class CHSeriesDetailDownloadBrochureModel {
  private readonly fields: any;
  private readonly rendering?: ComponentRendering;
  private readonly params?: TCHSeriesDetailDownloadBrochuresParams;

  constructor(props: TCHSeriesDetailDownloadBrochuresProps) {
    this.fields = props?.fields || null;
    this.rendering = props?.rendering;
    this.params = props?.params;
  }

  get backgroundColor(): string | undefined {
    return BACKGROUND_COLOR_MAP.get(this.params?.backgroundColor || '');
  }

  get thumbnailEE(): string {
    return this.fields?.itemData?.thumbnail || '';
  }

  get componentName(): string {
    return this.rendering?.componentName || '';
  }

  get title(): StringField {
    return { value: this.fields?.apiData?.brochures?.title || null };
  }

  get eyebrow(): StringField {
    return { value: this.fields?.apiData?.brochures?.eyebrow || null };
  }

  get description(): StringField {
    return { value: appendRootToRichTextInternalLinks(this.fields?.apiData?.brochures?.description || null) };
  }

  get assets(): TCHSeriesDetailDownloadBrochuresInnerComponent[] {
    return this.fields?.apiData?.brochures || [];
  }

  get downloadBrochureCard(): TCHSeriesDetailDownloadBrochuresDataAssets[] {
    return this.fields?.apiData?.brochures?.assets.map((item) => {
      return {
        ...item,
        icon: this.fields?.itemData?.iconsList || [],
      };
    });
  }

  get thumbnail(): string {
    return this.fields?.apiData?.assets?.[0]?.thumbnail;
  }

  get canShowComponent(): boolean {
    return Boolean(
      this.fields?.apiData?.brochures?.title ||
        this.fields?.apiData?.brochures?.description ||
        this.fields?.apiData?.brochures?.eyebrow ||
        this.fields?.apiData?.brochures?.assets?.length > 0
    );
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }

  get contextItemUrl(): string {
    return this.fields?.itemData?.contextItemUrl || '';
  }
}
